// sanity client

import { createClient } from "@sanity/client";

export default createClient({
  projectId: "fu7urkn4",
  dataset: "production",
});
